export interface IRegisterReason {
    value: string;
    name: string;
}

const getRegisterReasons = (lng: string) => {
    if (lng === 'fr') {
        return [
            {
                name: 'Demande de mes clients',
                value: 'Demand from clients',
            },
            {
                name: 'Demande du proprétaire/gestionnaire de la clinique/bannière',
                value: 'Clinic/banner owner/manager request',
            },
            {
                name: 'Différencier la pratique de la concurrence',
                value: 'To differentiate my practice from the competition',
            },
            {
                name: 'Mieux servir mes clients',
                value: 'To better serve my clients',
            },
            {
                name: 'Recommandation d\'un(e) collègue',
                value: 'Recommendation from colleague',
            },
            {
                name: 'Autre (spécifiez)',
                value: 'Other',
            },
        ] as IRegisterReason[];
    } else {
        return [
            {
                name: 'Clinic/banner owner/manager request',
                value: 'Clinic/banner owner/manager request',
            },
            {
                name: 'Demand from clients',
                value: 'Demand from clients',
            },
            {
                name: 'Recommendation from colleague',
                value: 'Recommendation from colleague',
            },
            {
                name: 'To better serve my clients',
                value: 'To better serve my clients',
            },
            {
                name: 'To differentiate my practice from the competition',
                value: 'To differentiate my practice from the competition',
            },
            {
                name: 'Other',
                value: 'Other',
            },
        ] as IRegisterReason[];
    }
};

export default getRegisterReasons;
